<template>
  <div
    :class="cn('group/card group-has-[div]:mt-0 [&:not(:first-child)]:mt-5', String($attrs.class || ''))"
  >
    <UiCard
      class="card relative flex flex-col h-full overflow-hidden transition-all min-h-8 border-none shadow-none"
      :class="[
        // to && 'hover:shadow-lg',
        inStack && 'mb-0 rounded-none border-none shadow-none',
        ['left', 'right'].includes(mediaPosition) && 'flex-row',
        mediaPosition === 'right' && 'flex-row-reverse',
        mediaPosition === 'bottom' && 'flex-col-reverse justify-between',
        ['cover', 'center'].includes(mediaPosition) && 'bg-opacity-0',
        mediaPosition === 'center' && 'text-center items-center flex-row p-8',
      ]"
    >
      <div
        v-if="media || $slots.media"
        class="card__media overflow-hidden"
        :class="{
          'w-5/13 shrink-0': (media || $slots.media) && (mediaPosition === 'left' || mediaPosition === 'right'),
          'absolute inset-0': ['cover', 'center'].includes(mediaPosition),
        }"
      >
        <NuxtImg
          v-if="media"
          :src="media"
          class="w-full h-full object-cover aspect-video"
          :class="{
            'group-hover/card:scale-105 transition-all': to,
          }"
        />
        <MDCSlot name="media"
          unwrap="p"
        />
      </div>

      <div class="w-full z-1">
        <UiCardHeader
          v-if="
            icon || title || $slots.title || description || $slots.description
          "
          class="card__header"
          :class="{
            'flex-row gap-5': iconPosition === 'left',
            'items-center': mediaPosition === 'center',
          }"
        >
          <Icon
            v-if="icon"
            :name="icon"
            :size="iconSize"
            :class="{ 'mb-2': iconPosition !== 'left' && (title || $slots.title) }"
          />

          <div class="flex flex-col gap-2 w-full">
            <div
              v-if="date || tag"
              class="flex gap-2 items-center"
            >
              <div
                v-if="date"
                class="card__date text-base text-muted-foreground pt-1"
                style="text-decoration: none !important"
              >
                {{ new Intl.DateTimeFormat(locale, { dateStyle: 'long' }).format(new Date(date)) }}
              </div>
              <Badge
                v-if="tag && typeof tag === 'string'"
                variant="fill"
                type="primary"
              >
                {{ tag }}
              </Badge>
              <div
                v-else-if="tag && Array.isArray(tag)"
                class="flex gap-2"
              >
                <Badge
                  v-for="(t, i) in tag"
                  :key="t"
                  variant="fill"
                  :type="i === 0 ? 'primary' : 'default'"
                >
                  {{ t }}
                </Badge>
              </div>
            </div>

            <NuxtLinkLocale
              v-if="to"
              :to
              :target
            >
              <h3
                v-if="title || $slots.title"
                class="card__title text-2xl font-semibold leading-tight tracking-tight text-pretty"
                :class="{ 'group-hover/card:underline': to, 'pr-4': ['left', 'bottom'].includes(mediaPosition) && to }"
              >
                <MDCSlot name="title"
                  unwrap="p"
                />
                <MDC
                  v-if="title"
                  :value="title"
                  unwrap="p"
                />
              </h3>
            </NuxtLinkLocale>

            <UiCardDescription
              v-if="description || $slots.description"
              class="card__description"
            >
              <MDCSlot name="description"
                unwrap="p"
              />
              <client-only>
                <MDC
                  v-if="description"
                  :value="description"
                  unwrap="p"
                />
              </client-only>
              <!-- v-if="description" -->
              <!-- <MDC
                v-if="description"
                :value="description || ''"
                unwrap="p"
              /> -->
              <!-- {{ description }} -->
            </UiCardDescription>
          </div>
        </UiCardHeader>

        <UiCardContent
          v-if="content || $slots.content || $slots.default"
          class="card__content"
          :class="{ 'py-3': !icon && !(title || $slots.title) && !(description || $slots.description) }"
        >
          <MDCSlot unwrap="p" />
          <MDCSlot name="content"
            unwrap="p"
          />
        </UiCardContent>

        <UiCardFooter
          v-if="footer || $slots.footer"
          class="card__footer"
        >
          <MDCSlot name="footer"
            unwrap="p"
          />
          <MDC
            v-if="footer"
            :value="footer"
            unwrap="p"
          />
        </UiCardFooter>

        <LinkIcon
          v-if="showLinkIcon"
          :to
          :target
          :external
        />
      </div>
    </UiCard>
  </div>
</template>

<script setup lang="ts">
import { cn } from '@/lib/utils'

defineOptions({
  inheritAttrs: false,
})

const {
  title,
  to,
  external = undefined,
  showLinkIcon = false,
  iconSize = 24,
  iconPosition = 'left',
  mediaPosition = 'right',
} = defineProps<{
  title?: string
  description?: string
  date?: string
  content?: string
  footer?: string
  tag?: string | string[]

  to?: string
  target?: Target
  external?: boolean
  showLinkIcon?: boolean

  icon?: string
  iconSize?: number
  iconPosition?: 'top' | 'left'

  media?: string
  mediaPosition?: 'left' | 'right' | 'top' | 'bottom' | 'cover' | 'center'

  inStack?: boolean
}>()

const { locale } = useI18nDocs()

defineSlots()

// const _slots: SetupContext['slots'] = useSlots()
// console.log(_slots)
</script>
